import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';

import Spinner from 'admin-components/components/Spinner';

import Icon from '../Icons';

import { StyledButton, ButtonContent, SpinnerContainer } from './Button.styles';

const Button = ({
  element,
  href,
  onClick,
  loading,
  label,
  loadingLabel = '',
  icon = '',
  showTip,
  textIdTip,
  children,
  variant,
  ...rest
}) => {
  let buttonProps = {};

  if (element) {
    buttonProps = { element, ...rest };
  } else if (href) {
    buttonProps = { href, element: 'a', ...rest };
  } else {
    buttonProps = { onClick, element: 'button', ...rest };
  }

  return (
    <>
      <StyledButton
        {...buttonProps}
        data-id="Button"
        data-tip
        data-for="Button-tooltip"
        variant={variant}
        $showTip={showTip}
        $hasLabel={Boolean(label)}
      >
        {loading && (
          <SpinnerContainer>
            <Spinner data-testid="Spinner" type={'circular'} height={2} />
          </SpinnerContainer>
        )}
        <ButtonContent disabled={loading} data-id="ButtonContent">
          {!loading && (label || children)}
          {loading && (loadingLabel || label || children)}
          {icon && <Icon icon={icon} data-testid="Icon" />}
        </ButtonContent>
      </StyledButton>
      {showTip && textIdTip ? (
        <ReactTooltip id="Button-tooltip" data-id="Button-tooltip" data-cy="Button-tooltip">
          <FormattedMessage id={textIdTip} />
        </ReactTooltip>
      ) : null}
    </>
  );
};

Button.propTypes = {
  element: PropTypes.element,
  href: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  showTip: PropTypes.bool,
  textIdTip: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loadingLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  autoFocus: PropTypes.bool,
  textDecoration: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  icon: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary'])
};

export default Button;
